import { apiClient } from '@/lib/api'
import type { Flow } from '@/lib/flows'
import type { AccountRole } from '@/types/auth'

export interface RoleWriteBody {
  name: string
  flows: Flow[]
}

export function fetchRoles() {
  return apiClient<AccountRole[]>('/roles')
}

export function createRole(body: RoleWriteBody) {
  return apiClient<AccountRole>('/roles', { method: 'POST', body })
}

export function updateRole(id: string, body: RoleWriteBody) {
  return apiClient<AccountRole>(`/roles/${id}`, { method: 'PUT', body })
}

export function deleteRole(id: string) {
  return apiClient<void>(`/roles/${id}`, { method: 'DELETE' })
}
